
import AppConfig from "../../config/AppConfig";
export default function TableAdmin({ title, content }) {
    const updateApplicationStatus = (applicationId, status) => {
        const apiUrl = AppConfig.API_BASE_URL+`application/approved/${applicationId}/${status}`
        fetch(apiUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body:{reason:"Accepter"}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Erreur lors de la mise à jour du statut');
                }
                window.location.reload();
            })
            .catch(error => {
                console.error('Erreur:', error);
            });
    };
    const handleClick = (id, status) => {
        updateApplicationStatus(id, status);
    };
    return (
        <div>
            <h5 className="card-header">{title}</h5>
            <div className="table-responsive text-nowrap">
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Date Creation</th>
                        <th>Date Validation</th>
                        <th>Solde USD</th>
                        <th>Solde CDF</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                    {content.map((item, index) => (
                        <tr key={index}>
                            <td>{item["Nom"]}</td>
                            <td>{item["Date creation"]}</td>
                            <td>{item["Date validation"]}</td>
                            <td>{item["Solde USD"]}</td>
                            <td>{item["Solde CDF"]}</td>
                            <td>
                                {item["Status"] === 'REQUESTED' && (
                                    <>
                                    <span class="badge bg-label-info">{item["Status"]}</span>
                                    </>
                                )}
                                {item["Status"] === 'APPROVED' && (
                                    <>
                                        <span class="badge bg-label-success">{item["Status"]}</span>
                                    </>
                                )}
                                {item["Status"] === 'DISAPPROVED' && (
                                    <>
                                        <span class="badge bg-label-warning">{item["Status"]}</span>
                                    </>
                                )}
                                {item["Status"] === 'DISABLED' && (
                                    <>
                                        <span class="badge bg-label-danger">{item["Status"]}</span>
                                    </>
                                )}
                            </td>
                            {content.length > 0 ? <td>
                                <div className="dropdown">
                                    <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                            data-bs-toggle="dropdown">
                                        <i className="bx bx-dots-vertical-rounded"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                        {item["Status"] === 'REQUESTED' && (
                                            <>
                                                <button className="dropdown-item" onClick={() => handleClick(item.id,"APPROVED")}>
                                                    <i className="bx bx-trash me-1"></i> Approuver
                                                </button>
                                                <button className="dropdown-item" onClick={() => handleClick(item.id,"DISAPPROVED")}>
                                                    <i className="bx bx-trash me-1"></i> Désapprouver
                                                </button>
                                            </>
                                        )}
                                        {item["Status"] === 'APPROVED' && (
                                            <button className="dropdown-item" onClick={() => handleClick(item.id,"DISABLED")}>
                                                <i className="bx bx-trash me-1"></i> Désactiver
                                            </button>
                                        )}
                                        {item["Status"] === 'DISAPPROVED' && (
                                            <button className="dropdown-item" onClick={() => handleClick(item.id,"APPROVED")}>
                                                <i className="bx bx-trash me-1"></i> Réapprouver
                                            </button>
                                        )}
                                        {item["Status"] === 'DISABLED' && (
                                            <button className="dropdown-item" onClick={() => handleClick(item.id,"APPROVED")}>
                                                <i className="bx bx-trash me-1"></i> Réapprouver
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </td> : ""}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}